module.exports = __webpack_public_path__ + "img/map2.d71636ff.jpg";